import { cx } from '../lib/util.js';

export function Modal({ open, onClose, title, children, accent = 'teal', wide, footer }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/85" onClick={onClose} aria-hidden="true" />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className={cx(
          'animate-sg-pop relative w-full border border-edge bg-panel text-snow',
          'shadow-[0_0_80px_rgba(0,0,0,0.9)]',
          accent === 'ember' ? 'border-t-2 border-t-ember' : 'border-t-2 border-t-neon',
          wide ? 'max-w-3xl' : 'max-w-md'
        )}
      >
        <div className="flex items-center justify-between border-b border-edge px-5 py-3.5">
          <h3 className="font-mono text-sm font-bold uppercase tracking-[0.25em] text-snow">
            {title}
          </h3>
          <button
            onClick={onClose}
            aria-label="Close"
            className="grid h-8 w-8 place-items-center border border-edge font-mono text-sm text-mist transition-colors hover:border-ember hover:text-ember"
          >
            ✕
          </button>
        </div>
        <div className="max-h-[70vh] overflow-y-auto p-5">{children}</div>
        {footer && (
          <div className="flex items-center justify-end gap-2 border-t border-edge px-5 py-3.5">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}